import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "store";

type DismissedOnboardings = {
  detectorDetail: boolean;
  queryDetail: boolean;
  detectorManagement: boolean;
};

type OnboardingsState = {
  dismissed: Partial<DismissedOnboardings>;
};

const initialState: OnboardingsState = {
  dismissed: {},
};

const onboardingsSlice = createSlice({
  name: "account",
  initialState,
  reducers: {
    setDismissedOnboardings: (state, action: PayloadAction<Partial<DismissedOnboardings>>) => {
      state.dismissed = action.payload;
    },
  },
});

export const { setDismissedOnboardings } = onboardingsSlice.actions;

// Selectors
export const selectDismissedOnboardings = (state: RootState) => state.onboardings.dismissed;

export default onboardingsSlice;
